import { LocalizedName, MandatInfo, PartiResultat } from '../../domain'
import { flatSingle, repeat } from '../../../lib/array'

export type MandatTableItem = {
  navn: LocalizedName
  kortNavn: string
  antall?: number
  endringAntall?: number
  farge: string
  fargeSvak: string
}

type Mandat = {
  kortNavn: string
  farge: string
  fargeSvak: string
}

export function isVisible(partiResultat: PartiResultat) {
  return (
    partiResultat.parti.kategori === 1 ||
    (partiResultat.parti.kategori === 2 && (partiResultat.mandater || ({} as any)).antall > 0) ||
    (partiResultat.parti.kategori === 3 && (partiResultat.mandater || ({} as any)).antall > 0)
  )
}

export function toMandatTableItem(
  partiresultater: PartiResultat[],
  mandater?: MandatInfo
): MandatTableItem[] {
  const noMandatendring = mandater && mandater.endring === 0

  return partiresultater.filter(isVisible).map(partiresultat => {
    return {
      navn: partiresultat.parti.navn,
      kortNavn: partiresultat.parti.kortNavn,
      antall: partiresultat.mandater ? partiresultat.mandater.antall : 0,
      endringAntall:
        partiresultat.mandater && noMandatendring ? partiresultat.mandater.endring : undefined,
      farge: partiresultat.parti.farge,
      fargeSvak: partiresultat.parti.fargeSvak
    }
  })
}

export function toEnkeltmandater(partier: MandatTableItem[]): Mandat[] {
  return flatSingle(
    partier.map(({ antall, kortNavn, farge, fargeSvak }) =>
      repeat(antall || 0, { kortNavn, farge, fargeSvak })
    )
  )
}

export function sumAntall(partier: MandatTableItem[]) {
  return partier.reduce((acc, item) => (item.antall || 0) + acc, 0)
}
